import React from 'react';
import { useBreakpoint } from '@landr/maestro';
import * as Styled from './Content.styled';
import { ContentProps } from './Content.types';

const Content: React.FC<ContentProps> = ({
    children,
    contentPosition = 'left',
    ...props
}) => {
    const isMobile = useBreakpoint('md');
    const contentPadding = isMobile ? 'xxl' : 'mg';

    return (
        <Styled.Content
            contentPosition={contentPosition}
            py={contentPadding}
            {...props}
        >
            {children}
        </Styled.Content>
    );
};

Content.displayName = 'Section.Content';

export default Content;
